export const BRAND_PRIMARY = '#0b6e4f';
export const BRAND_PRIMARY_DARK = '#084c38';
export const BRAND_PRIMARY_LIGHT = '#e5f3ea';
export const BRAND_PRIMARY_TINT = 'rgba(11, 110, 79, 0.12)';
export const BRAND_PRIMARY_OVERLAY = 'rgba(11, 110, 79, 0.9)';
export const BRAND_BACKGROUND_GRADIENT =
  'radial-gradient(circle at 10% 10%, rgba(198, 230, 210, 0.6), transparent 50%), radial-gradient(circle at 90% 0%, rgba(170, 214, 187, 0.35), transparent 55%), linear-gradient(180deg, #f3fbf6 0%, #e5f3ea 100%)';
